import ApplicationController from './application_controller'
import {
  countryCodeFromAddressComponents,
  missingAddressComponents
} from '../lib/address_components'

export default class extends ApplicationController {
  static targets = [
    'streetNumber', 'route', 'locality', 'state', 'country', 'postalCode',
    'formattedAddress', 'countryCode', 'latitude', 'longitude', 'rawAddress',
    'form'
  ]

  static componentForm = {
    street_number: { field: 'short_name', target: 'streetNumber' },
    route: { field: 'long_name', target: 'route' },
    locality: { field: 'long_name', target: 'locality' },
    postal_town: { field: 'long_name', target: 'locality' },
    administrative_area_level_1: { field: 'short_name', target: 'state' },
    country: { field: 'long_name', target: 'country' },
    postal_code: { field: 'short_name', target: 'postalCode' }
  }

  connect () {
    const eventName = this.data.get('listen-to')
    document.addEventListener(eventName, this.fillInAddress())
  }

  capitalize (str) {
    if (typeof str === 'string') {
      return str.replace(/^\w/, c => c.toUpperCase())
    } else {
      return ''
    }
  }

  async fetchUkFullPostalCode (lat, lng) {
    const response = await fetch(`https://api.postcodes.io/postcodes?lon=${lng}&lat=${lat}`)
    const data = await response.json()

    return data.result?.[0]?.postcode
  }

  isIncompleteUkPostalCode (postalCode) {
    return postalCode && !postalCode.includes(' ')
  }

  dispatchComponentsCheckedEvent (event, place, missingComponents) {
    document.dispatchEvent(new CustomEvent('address-completion:components-checked', {
      detail: {
        missingComponents,
        place,
        role: event.type.split('.').pop()
      }
    }))
  }

  clearAddressFields (klass) {
    for (const type in klass.componentForm) {
      const descriptor = klass.componentForm[type]
      const targetName = descriptor.target
      if (this[`has${this.capitalize(targetName)}Target`]) {
        this[`${targetName}Target`].value = ''
      }
    }

    for (const targetName of ['countryCode', 'latitude', 'longitude']) {
      if (this[`has${this.capitalize(targetName)}Target`]) {
        this[`${targetName}Target`].value = ''
        if (targetName === 'countryCode') {
          this[`${targetName}Target`].dispatchEvent(new Event('change'))
        }
      }
    }
  }

  fillInAddress () {
    const klass = this.constructor
    const controller = this

    return function (event) {
      const place = event.detail.place || {}
      let detectedCountryCode = null

      const addressComponents = place.address_components || []
      const missingComponents = missingAddressComponents(place)

      controller.dispatchComponentsCheckedEvent(event, place, missingComponents)
      controller.clearAddressFields(klass)

      if (addressComponents.length > 0) {
        for (const component of addressComponents) {
          // Check all types in the component, not just the first one
          let descriptor = null
          for (const type of component.types) {
            if (klass.componentForm[type]) {
              descriptor = klass.componentForm[type]
              break
            }
          }

          if (descriptor) {
            const val = component[descriptor.field]
            if (controller[`has${controller.capitalize(descriptor.target)}Target`]) {
              controller[`${descriptor.target}Target`].value = val
            }
          }

          if (component.types.includes('country') && controller.hasCountryCodeTarget) {
            controller.countryCodeTarget.value = component.short_name
            controller.countryCodeTarget.dispatchEvent(new Event('change'))
          }
        }
      }

      const formattedAddress = place.formatted_address || place.name || ''
      detectedCountryCode = countryCodeFromAddressComponents(addressComponents)

      if (place.geometry) {
        const location = place.geometry.location

        if (controller.hasLatitudeTarget) {
          controller.latitudeTarget.value = location.lat()
        }

        if (controller.hasLongitudeTarget) {
          controller.longitudeTarget.value = location.lng()
        }

        if (detectedCountryCode === 'GB' &&
            controller.hasPostalCodeTarget &&
            controller.isIncompleteUkPostalCode(controller.postalCodeTarget.value)) {
          controller.fetchUkFullPostalCode(location.lat(), location.lng())
            .then(fullPostalCode => {
              if (fullPostalCode) {
                controller.postalCodeTarget.value = fullPostalCode
              }
            })
            .catch(() => {
            })
        }
      }

      if (controller.hasRawAddressTarget) {
        controller.rawAddressTarget.value = formattedAddress
      }

      if (controller.hasFormattedAddressTarget) {
        controller.formattedAddressTarget.value = formattedAddress
      }

      if (controller.hasFormTarget) {
        controller.formTarget.dispatchEvent(new Event('completion_complete'))
      }
    }
  }
}
